import { Component, OnInit } from '@angular/core';
import { CarouselService } from '../_services/carousel.service';
import { Produtos } from '../_model/produtos';
import { ProdutosService } from '../_services/produtos.service';
import { MarcasService } from '../_services/marcas.service';
import { Marcas } from '../_model/marcas';
import { NewsService } from '../_services/news.service';
import { Noticias } from '../_model/Noticias';
import { environment } from 'src/environments/environment';
import { CarouselBD } from '../_model/carousel';
import { DestaquesService } from '../_services/destaques.service';
import { Destaques } from '../_model/Destaques';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.less'],
    standalone: false
})
export class HomeComponent implements OnInit {

  constructor(private car: CarouselService, private prod: ProdutosService,
      private marca: MarcasService, private news: NewsService,
      private desc: DestaquesService, private sanatizer: DomSanitizer) {
  }

  apiUrl = environment.apiUrl;

  produtos: Produtos[] = [];

  marcas: Marcas[] = [];

  tMarcas: Marcas[] = [];
  brandMarcas: Marcas[] = [];

  mMedias: any[] = [];

  carousel: CarouselBD[] = [];

  noticias: Noticias[] = [];

  destaque: Destaques = new Destaques();

  dLink;

  ngOnInit() {
    this.car.list().subscribe((data: CarouselBD[]) => {
      this.carousel = data;
    });
    this.prod.list().subscribe((data: any) => {
      var temp = data;
      temp.forEach(el => {
        this.produtos.push(new Produtos(el));
      });
    });
    this.marca.listRandom().subscribe((data: any[]) => {
      data.forEach(el => {
        this.marcas.push(new Marcas(el));
        this.tMarcas.push(new Marcas(el));
        this.mMedias.push({ 
          media:"https://"+this.apiUrl+"/api/marcas/image/"+el.id+"/"+el.media.split(";")[0],
          link: el.link != '' ? el.link : "/produtos?query=&marca="+el.id+"&type=",
          external: el.link != ''
        });
      });
    });
    this.news.list().subscribe((data: any[]) => {
      data.forEach(el => {
        this.noticias.push(new Noticias(el));
      })
    });
    this.desc.getDestaque().subscribe((data: any) => {
      this.destaque = new Destaques(data);
      if(this.destaque.typeMedia) {
        this.dLink = this.cleanUrl(this.transformEmbedLink(this.destaque.media));
      }
    });
  }

  cleanUrl(url: string) {
    return this.sanatizer.bypassSecurityTrustResourceUrl(url);
  }

  get(id) {
    return this.tMarcas?.filter(x => x.id == id)[0]?.nome
  }

  filter(filter) {
    this.mMedias = [];
    this.marcas = [];
    if(filter != '') {
      this.marca.listPathOrder(filter).subscribe((data: Marcas[]) => {
        data.forEach(el => {
          this.marcas.push(new Marcas(el));
          this.mMedias.push({ 
            media:"https://"+this.apiUrl+"/api/marcas/image/"+el.id+"/"+el.media.split(";")[0],
            link:"/produtos?query=&marca="+el.id+"&type="
          });
        });
      });
    }else{
      this.marca.listRandom().subscribe((data: any[]) => {
        data.forEach(el => {
          this.marcas.push(new Marcas(el));
          this.mMedias.push({ 
            media:"https://"+this.apiUrl+"/api/marcas/image/"+el.id+"/"+el.media.split(";")[0],
            link: el.link != '' ? el.link : "/produtos?query=&marca="+el.id+"&type=",
            external: el.link != ''
          });
        });
      });
    }
    console.log(this.mMedias);
  }

  getLinkId(url: string) {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);

    return (match && match[2].length === 11) ? match[2] : null;
  }

  transformEmbedLink(url: string) {
    return "//www.youtube.com/embed/" + this.getLinkId(url) ;
  }

  price(price: number): string {
    var temp = price.toString().split("");
    var result ="";
    var ctrl = 0;
    for(var i = temp.length - 1; i >= 0; i--) {
      if(ctrl == 2 && i != 0) {
        result = "."+temp[i] + result;
        ctrl = 0;
      }else{
        result = temp[i] + result;
        ctrl++;
      }
    }
    return result+" €";
  }

}
